import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import classNames from 'classnames';
import type { AdItem } from '@sbt-web/network/types';
import { ShareComponent } from '@sbt-web/share-button';
import { AD_SHARING_TITLE } from '@/shared/constants';
import { AdAbuse } from '../AdAbuse';
import css from './index.module.scss';
interface Props {
  item: AdItem;
}
export const BottomBar: FC<Props> = t0 => {
  const $ = _c(17);
  const {
    item
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      shareButton: _temp,
      closeModal: _temp2,
      shareWithNativeApi: "sharing-icon-bottom-customsocial",
      messenger: "sharing-icon-bottom-mess",
      facebook: "sharing-icon-bottom-facebook",
      whatsApp: "sharing-icon-bottom-whatsapp",
      copyUrl: "sharing-icon-bottom-copylink"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== item.category || $[2] !== item.urn) {
    t2 = <ShareComponent design="text" adTrackInfo={{
      urn: item.urn,
      category: item.category,
      trackIds: t1
    }} className={css["ad-bottom__share-btn"]} sharingTitle={AD_SHARING_TITLE} sharingUrl={_temp3}>Condividi</ShareComponent>;
    $[1] = item.category;
    $[2] = item.urn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item) {
    t3 = <AdAbuse item={item} />;
    $[4] = item;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={css["ad-bottom__buttons"]}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classNames(css["ad-bottom__ad-id"], "caption book");
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== item.urn) {
    t6 = item.urn.split(":");
    $[10] = item.urn;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6[4]) {
    t7 = <p className={t5}>ID: {t6[4]}</p>;
    $[12] = t6[4];
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={css["ad-bottom-container"]}>{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default BottomBar;
function _temp() {
  return "sharing-icon-bottom";
}
function _temp2() {
  return "close-sharing-bottom-modal";
}
function _temp3() {
  const canonicalLink = document.querySelector("link[rel='canonical']");
  const link = canonicalLink?.href ?? window.location.href;
  return `${link}?utm_medium=referral&utm_source=subito&utm_campaign=free-engagement-ad_detail`;
}